/* eslint-disable quotes */
/* eslint-disable indent */
export default [
    {
        path: "/chats",
        name: "chats",
        component: () => import("@/views/chats/Chat.vue"),
        meta: {
            pageTitle: "Chats",
            allowedAccountTypes: ["agency", "admin", "employer"],
            allowAnonymous: false,
        },
    },
]
